import React from 'react';
import { motion } from 'framer-motion';

interface HeaderProps {
  activeTab: 'create' | 'gallery';
  setActiveTab: (tab: 'create' | 'gallery') => void;
}

const Header: React.FC<HeaderProps> = ({ activeTab, setActiveTab }) => {
  return (
    <header className="bg-dark-800 border-b border-dark-600 py-3 px-4 sticky top-0 z-10">
      <div className="w-full flex flex-col md:flex-row items-center justify-between">
        <div className="flex items-center mb-4 md:mb-0 ml-0">
          <motion.div
            initial={{ rotate: -10 }}
            animate={{ rotate: 0 }}
            transition={{ duration: 0.5 }}
            className="mr-2 text-2xl"
          >
            🎨
          </motion.div>
          <h1 className="text-xl md:text-2xl font-display font-bold">
            <span className="gradient-text">AI绘画助手</span>
          </h1>
        </div>
        
        <nav className="flex space-x-1 mr-0">
          <button
            onClick={() => setActiveTab('create')}
            className={`btn py-1 px-3 text-sm ${
              activeTab === 'create'
                ? 'bg-primary-600 text-white'
                : 'bg-dark-700 text-dark-200 hover:bg-dark-600'
            } transition-all duration-200`}
          >
            创作
          </button>
          <button
            onClick={() => setActiveTab('gallery')}
            className={`btn py-1 px-3 text-sm ${
              activeTab === 'gallery'
                ? 'bg-primary-600 text-white'
                : 'bg-dark-700 text-dark-200 hover:bg-dark-600'
            } transition-all duration-200`}
          >
            画廊
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
